<template>
  <div class="home-group-wrapper">
    <PatientFilter :showPatientBox="false" />
    <Helper />
    <b-row :class="dashboardClass">
      <b-col cols="12" lg="6" class="action-column">
        <div class="module">
          <div class="module-title pt-5 pb-5 mb-5 v-h-center">
            {{ $t('text.action_required') }}
          </div>
          <div
            class="module-content"
            v-if="actions.top.length || actions.bottom.length"
          >
            <div
              v-for="(actionModule, key) in actions"
              :key="key"
              :class="key + '-action-section'"
              class="dashboard-item-card-wrapper"
            >
              <div
                class="dashboard-item-card pointer"
                v-for="(item, index) in actionModule"
                :key="item.patientId + index"
                @click="toIndividual(item)"
                :class="{
                  'fall-animate-bg':
                    getActiveType(item).type === actionType.check_fall &&
                    !$store.getters[`user/isSimpleMode`],
                  'high-light-patient': hightLightPatientId === item.patientId,
                  'fall-red-bg':
                    getActiveType(item).type === actionType.check_fall &&
                    $store.getters[`user/isSimpleMode`]
                }"
              >
                <img
                  src="@/assets/image/goal-flag-icon.png"
                  class="goal-active"
                  v-if="item.data.isGoalEnabled"
                />
                <!-- Only show red and empty battery icon, and don't show it when pod lost connection -->
                <div
                  class="smartz-battery-icon blinks"
                  v-if="
                    [batteryStatus.red, batteryStatus.empty].includes(
                      item.data.batteryStatus
                    ) && item.data.podStatus !== 'NODATARECEIVED'
                  "
                >
                  <div
                    class="smartz-battery-icon-bar"
                    :style="{
                      background: '#DD808C',
                      width:
                        item.data.batteryStatus === batteryStatus.red
                          ? '10%'
                          : 0
                    }"
                  ></div>
                </div>
                <!-- Only show upgrade icon when isUpgraded is false -->
                <div class="upgrade-icon" v-if="!item.data.isUpgraded">
                  <svg-icon iconClass="upgrade" class="w-15"></svg-icon>
                </div>

                <!-- If user in privacy mode, then only show general info -->
                <div v-if="$store.getters[`user/isPrivacyMode`]">
                  <div
                    class="privacy-circle v-h-center"
                    :class="
                      'level-' +
                        getActionNotificationInfo(item).privacyEventClass
                    "
                  >
                    <div class="v-h-center inner-level-circle">
                      <div>{{ item.alias }}</div>
                    </div>
                  </div>
                  <div
                    class="privacy-time v-h-center"
                    v-if="calculateTime(item)[0]"
                  >
                    <span>
                      {{ calculateTime(item)[0]
                      }}{{ calculateTime(item)[1] }}</span
                    >
                  </div>
                </div>
                <!-- If user in simple mode, show simple mode layout -->
                <div v-else-if="$store.getters[`user/isSimpleMode`]">
                  <div class="mb-12 bg-white pt-5 pb-5 border-radius-5">
                    {{ item.alias }}
                  </div>
                  <div
                    class="circle v-h-center"
                    :class="
                      'level-' +
                        getActionNotificationInfo(item).simpleCircleClass
                    "
                  >
                    <img
                      :src="
                        require('@/assets/image/NotificationIcons/' +
                          getActionNotificationInfo(item).simpleImgSrc)
                      "
                      :class="getActionNotificationInfo(item).simpleImgClass"
                      :key="Math.random()"
                    />
                  </div>
                </div>
                <!-- If normal mode, show all information -->
                <div v-else>
                  <div class="mb-12">{{ item.alias }}</div>
                  <div
                    class="third-circle"
                    v-if="item.warnings.length > 2"
                  ></div>
                  <div
                    class="circle v-h-center"
                    :class="{
                      'circle-double': item.warnings.length > 1,
                      'fall-circle-bg':
                        getActiveType(item).type === actionType.check_fall
                    }"
                  >
                    <div class="time" v-if="calculateTime(item)[0]">
                      <span>
                        {{ calculateTime(item)[0]
                        }}{{ calculateTime(item)[1] }}</span
                      >
                    </div>
                    <img
                      :src="
                        require('@/assets/image/NotificationIcons/' +
                          getActionNotificationInfo(item).imgSrc)
                      "
                      :class="getActionNotificationInfo(item).class"
                      :key="Math.random()"
                    />
                  </div>
                </div>

                <!-- privacy mode or simple mode: show warning placeholder list -->
                <div
                  class="privacy-warning-placeholder-list"
                  :class="item.warnings.length < 2 ? 'visibile-hide' : ''"
                  v-if="
                    $store.getters[`user/isPrivacyMode`] ||
                      $store.getters[`user/isSimpleMode`]
                  "
                >
                  <span
                    class="warning-placeholder"
                    :class="warning.active ? 'active' : ''"
                    v-for="(warning, key) in item.warnings"
                    :key="key"
                  ></span>
                </div>

                <div
                  class="mb-5 mt-5 warn-text"
                  :class="
                    $store.getters[`user/isPrivacyMode`] ||
                    $store.getters[`user/isSimpleMode`]
                      ? 'red-text bg-white pt-5 pb-5 h-26 border-radius-5'
                      : ''
                  "
                >
                  {{
                    $store.getters[`user/isPrivacyMode`] ||
                    $store.getters[`user/isSimpleMode`]
                      ? getActionNotificationInfo(item).bottomLightText
                        ? getActionNotificationInfo(
                            item
                          ).bottomLightText.toUpperCase()
                        : getActionNotificationInfo(item).text.toUpperCase()
                      : getActionNotificationInfo(item).text.toUpperCase()
                  }}
                </div>
                <div class="light-font">
                  <span
                    v-if="
                      getActionNotificationInfo(item).bottomLightText &&
                        !$store.getters[`user/isPrivacyMode`] &&
                        !$store.getters[`user/isSimpleMode`]
                    "
                  >
                    {{ getActionNotificationInfo(item).bottomLightText }}
                  </span>
                </div>
                <img
                  v-if="
                    item.data.rssiStatus !== 'GOOD' &&
                      getActiveType(item).type !== actionType.no_data_received
                  "
                  src="@/assets/image/NotificationIcons/wifi.png"
                  class="low-rssi-icon"
                />
              </div>
            </div>
          </div>
          <div class="no-data mt-10" v-else v-loading="loading"></div>
        </div>
      </b-col>
      <b-col cols="12" lg="6" class="monitors-column">
        <div class="module">
          <div class="module-title pt-5 pb-5 mb-5 v-h-center">
            {{ $t('text.monitor') }}
            <div
              class="add-patient-icon"
              @click="addPatient"
              v-if="p('Patients.Add')"
            >
              <span class="mr-5">{{ $t('text.add').toUpperCase() }}</span>
              <img src="@/assets/image/user-icon-add.png" />
            </div>
          </div>
          <div
            class="module-content"
            v-if="monitors.top.length || monitors.bottom.length"
          >
            <div
              v-for="(monitorModule, key) in monitors"
              :key="key"
              :class="key + '-monitor-section'"
              class="dashboard-item-card-wrapper"
            >
              <div
                class="dashboard-item-card pointer"
                v-for="(item, index) in monitorModule"
                :key="item.patientId + index"
                @click="toIndividual(item)"
                :class="{
                  'high-light-patient': hightLightPatientId === item.patientId
                }"
              >
                <img
                  src="@/assets/image/goal-flag-icon.png"
                  class="goal-active"
                  v-if="item.data.isGoalEnabled"
                />
                <!-- Only show red and empty battery icon, and don't show it when pod lost connection -->
                <div
                  class="smartz-battery-icon blinks"
                  v-if="
                    [batteryStatus.red, batteryStatus.empty].includes(
                      item.data.batteryStatus
                    ) && item.data.podStatus !== 'NODATARECEIVED'
                  "
                >
                  <!-- Just visual battery in group dashboard, so width is fixed -->
                  <div
                    class="smartz-battery-icon-bar"
                    :style="{
                      background: '#DD808C',
                      width:
                        item.data.batteryStatus === batteryStatus.red
                          ? '10%'
                          : 0
                    }"
                  ></div>
                </div>
                <!-- Only show upgrade icon when isUpgraded is false -->
                <div class="upgrade-icon" v-if="!item.data.isUpgraded">
                  <svg-icon iconClass="upgrade" class="w-15"></svg-icon>
                </div>

                <!-- If user in privacy mode, then only show general info -->
                <div v-if="$store.getters[`user/isPrivacyMode`]">
                  <div
                    class="privacy-circle v-h-center"
                    :class="
                      'level-' +
                        getMonitorNotificationInfo(item).privacyEventClass
                    "
                  >
                    <div class="v-h-center inner-level-circle">
                      <div>{{ item.alias }}</div>
                    </div>
                  </div>
                </div>
                <!-- If simple mode, show simple mode layout -->
                <div v-else-if="$store.getters[`user/isSimpleMode`]">
                  <div class="mb-12 bg-white pt-5 pb-5 border-radius-5">
                    {{ item.alias }}
                  </div>
                  <div
                    class="circle v-h-center"
                    :class="
                      'level-' +
                        getMonitorNotificationInfo(item).simpleCircleClass
                    "
                  >
                    <img
                      v-if="getMonitorNotificationInfo(item).simpleImgSrc"
                      :class="getMonitorNotificationInfo(item).simpleImgClass"
                      :src="
                        require('@/assets/image/NotificationIcons/' +
                          getMonitorNotificationInfo(item).simpleImgSrc)
                      "
                    />
                  </div>
                </div>
                <!-- If normal mode, show all information -->
                <div v-else>
                  <div class="mb-12">{{ item.alias }}</div>
                  <div class="circle v-h-center">
                    <div :class="getMonitorNotificationInfo(item).divClass">
                      <img
                        v-if="getMonitorNotificationInfo(item).imgSrc"
                        :class="getMonitorNotificationInfo(item).imgClass"
                        :src="
                          require('@/assets/image/NotificationIcons/' +
                            getMonitorNotificationInfo(item).imgSrc)
                        "
                      />
                    </div>
                  </div>
                </div>

                <!-- privacy mode or simple mode: show warning placeholder list -->
                <div
                  class="privacy-warning-placeholder-list visibile-hide"
                  v-if="
                    $store.getters[`user/isPrivacyMode`] ||
                      $store.getters[`user/isSimpleMode`]
                  "
                ></div>

                <div
                  class="mt-5"
                  :class="
                    $store.getters[`user/isPrivacyMode`] ||
                    $store.getters[`user/isSimpleMode`]
                      ? 'bg-white pt-5 pb-5 h-26 border-radius-5 ' +
                        getMonitorNotificationInfo(item)
                          .simpleOrPrivacyBottomTextClass
                      : ''
                  "
                >
                  {{
                    $store.getters[`user/isPrivacyMode`] ||
                    $store.getters[`user/isSimpleMode`]
                      ? getMonitorNotificationInfo(item).bottomDesc
                        ? getMonitorNotificationInfo(
                            item
                          ).bottomDesc.toUpperCase()
                        : getMonitorNotificationInfo(item).text.toUpperCase()
                      : getMonitorNotificationInfo(item).text.toUpperCase()
                  }}
                </div>
                <div
                  class="mt-5 light-font"
                  v-if="
                    getMonitorNotificationInfo(item).bottomDesc &&
                      !$store.getters[`user/isPrivacyMode`] &&
                      !$store.getters[`user/isSimpleMode`]
                  "
                >
                  {{ getMonitorNotificationInfo(item).bottomDesc }}
                </div>
                <img
                  v-if="item.data.rssiStatus !== 'GOOD'"
                  src="@/assets/image/NotificationIcons/wifi.png"
                  class="low-rssi-icon"
                />
              </div>
            </div>
          </div>
          <div class="no-data mt-10" v-else v-loading="loading"></div>
          <EditPatient ref="editPatient" @saveSuccess="getData('all')" />
        </div>
      </b-col>
    </b-row>
    <div class="demo-mode" v-if="isDemoOrg">
      {{ $t('text.demonstration_mode') }}
    </div>
  </div>
</template>

<script>
import { actionType, monitorType, batteryStatus } from '@/const.js'
import ApiService from '@/services/ApiService.js'
import $ from 'jquery'
import moment from 'moment'
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import _ from 'lodash'
import Helper from '@/components/Helper.vue'
import PatientFilter from '@/components/dashboard/PatientFilter.vue'
import { MessageBox } from 'element-ui'

export default {
  data() {
    return {
      actionType: actionType,
      monitorType: monitorType,
      batteryStatus: batteryStatus,
      activeTimer: '',
      actions: {
        top: [],
        bottom: []
      },
      monitors: {
        top: [],
        bottom: []
      },
      notShownMonitors: {
        top: [],
        bottom: []
      },
      monitorCycleTimer: {
        top: '',
        bottom: ''
      },
      notShownActions: {
        top: [],
        bottom: []
      },
      actionCycleTimer: {
        top: '',
        bottom: ''
      },
      totalItemCount: 0,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      loading: false,
      maxCycleScreenWidth: 991,
      maxCycleScreenHeight: 540,
      refreshDataTimer: '',
      eachRowItemCount: 3,
      cycleInterval: 5000,
      responseData: [],
      hightLightPatientId: null,
      showTimeGreaterThanMinutes: 10,
      checkNodeNetworkTimer: null,
      privacyTypes: {
        level1: 1,
        level2: 2,
        level3: 3,
        level4: 4,
        level5: 5,
        level6: 6
      },
      simpleTypes: {
        level1: 1,
        level2: 2,
        level3: 3,
        level4: 4,
        level5: 5,
        level6: 6
      },
      displayNodeNetworkError: false
    }
  },
  components: {
    EditPatient,
    Helper,
    PatientFilter
  },
  mounted() {
    this.activeTimer = setInterval(this.toogleActive, 5000)
    this.getData('all')

    let frequency = this.isDemoOrg ? 3 * 60 * 1000 : 180000
    this.refreshDataTimer = setInterval(() => {
      this.getData('all')
    }, frequency)

    window.addEventListener('resize', () => {
      this.clearFlipInterval()
      this.initData()
      this.getScreenWidth()
    })
    this.$hub.$on('patient-updated', this.onPatientUpdated)
    this.$hub.$on('patient-status-updated', this.onPatientStatusUpdated)
    this.$hub.$on('patient-moved', this.onPatientMoved)
    this.getHightLightPatient()

    // check node network
    this.checkNodeNetwork()
    this.checkNodeNetworkTimer = setInterval(this.checkNodeNetwork, 900000)
  },
  computed: {
    isDemoOrg() {
      let user = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : false
      const selectedOrganisation = user.organisations.filter(
        item => item.Active
      )
      if (selectedOrganisation && selectedOrganisation.length) {
        return selectedOrganisation[0].OrganisationName.IsDemo
      }
      return false
    },
    getActiveType() {
      return function(item) {
        let activeType = item.warnings.filter(ele => {
          return ele.active
        })
        return activeType[0]
      }
    },
    getActionNotificationInfo() {
      return item => {
        const type = this.getActiveType(item).type
        let info
        switch (type) {
          case this.actionType.pod_unclipped:
            info = {
              imgSrc: 'pod-unclipped.png',
              class: 'w-40 mb-5',
              text: this.$t('text.reclip').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level6,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'pod-unclipped.png',
              simpleImgClass: 'w-40'
            }
            break
          case this.actionType.no_data_received:
            info = {
              imgSrc: 'wifi-lost-svgrepo-com.svg',
              class: 'w-44',
              text: this.$t('text.lost_connect').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level6,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'simple-lost-connection.png',
              simpleImgClass: 'w-40'
            }
            break
          case this.actionType.lowbattery:
            info = {
              imgSrc: 'replace-battery.png',
              class: 'w-56',
              text: this.$t('text.replace_battery').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level2,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'simple-replace-battery.png',
              simpleImgClass: 'w-40'
            }
            break
          case this.actionType.flatbattery:
            info = {
              imgSrc: 'flat-battery.png',
              class: 'w-56',
              text: this.$t('text.replace_battery').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level2,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'simple-flat-battery.png',
              simpleImgClass: 'w-40'
            }
            break
          case this.actionType.check_position:
            info = {
              imgSrc: 'change-position.png',
              class: 'w-56',
              text: this.$t('text.change_position').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level2,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'simple-reposition.png',
              simpleImgClass: 'w-40'
            }
            break
          case this.actionType.check_temperature:
            info = {
              imgSrc: 'temperature-red.svg',
              class: 'w-22 h-40',
              text: this.$t('text.check_temperture').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level2,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'temperature-red.svg',
              simpleImgClass: 'w-22 h-40'
            }
            break
          case this.actionType.check_fall:
            info = {
              imgSrc: 'attend-fall.png',
              class: 'w-50',
              text: this.$t('text.attend_fall').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level2,
              simpleCircleClass: this.simpleTypes.level2,
              simpleImgSrc: 'attend-fall.png',
              simpleImgClass: 'w-46'
            }
            break
          case this.actionType.check_time_in_pad:
            // When padStatus=red, check another property padStatusTrigger
            // if 1 show text “Goal Time Exceed”, if 2 show text "Predicted Time Exceed", if 3 show text "Safe Time Exceed"
            info = {
              imgSrc: item.data.padStatusTrigger
                ? 'check-time-in-pad.png'
                : 'red-pad.png',
              class: 'w-56',
              text: this.$store.getters[`user/isPrivacyMode`]
                ? ''
                : this.$t('text.change').toUpperCase(),
              // bottomLightText:
              //   item.data.padStatusTrigger === 1
              //     ? this.$t('text.goal_time_exceed')
              //     : item.data.padStatusTrigger === 2
              //     ? this.$t('text.predicted_time_exceed')
              //     : item.data.padStatusTrigger === 3
              //     ? this.$t('text.safe_time_exceed')
              //     : '',
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level1,
              simpleCircleClass: this.simpleTypes.level1,
              simpleImgSrc: 'simple-pad.png',
              simpleImgClass: 'w-32'
            }
            break
          //actionType check_pad
          default:
            info = {
              imgSrc: 'red-pad.png',
              class: 'w-56',
              text: this.$store.getters[`user/isPrivacyMode`]
                ? ''
                : this.$t('text.change').toUpperCase(),
              bottomLightText: '',
              privacyEventClass: this.privacyTypes.level1,
              simpleCircleClass: this.simpleTypes.level1,
              simpleImgSrc: 'simple-pad.png',
              simpleImgClass: 'w-32'
            }
        }
        return info
      }
    },
    getMonitorNotificationInfo() {
      return item => {
        const type = item.common_value
        let info
        switch (type) {
          case this.monitorType.YELLOW:
            info = {
              divClass: 'monitor-yellow v-h-center',
              imgClass: 'w-32',
              imgSrc: 'pad.svg',
              text: '',
              bottomDesc: '',
              privacyEventClass: this.privacyTypes.level3,
              simpleCircleClass: this.simpleTypes.level3,
              simpleImgSrc: 'simple-pad.png',
              simpleImgClass: 'w-32',
              simpleOrPrivacyBottomTextClass: 'yellow-text'
            }
            break
          case this.monitorType['CLUMPED-GREEN']:
          case this.monitorType['CLUMPED-YELLOW']:
          case this.monitorType.UNSTABLE:
          case this.monitorType.CLUMPED:
          case this.monitorType.WETSURFACE:
          case this.monitorType.GREEN:
            info = {
              divClass: 'monitor-green v-h-center',
              imgClass: 'w-32',
              imgSrc: 'pad.svg',
              text: '',
              bottomDesc: '',
              privacyEventClass: this.privacyTypes.level5,
              simpleCircleClass: this.simpleTypes.level5,
              simpleImgSrc: 'simple-pad.png',
              simpleImgClass: 'w-32',
              simpleOrPrivacyBottomTextClass: 'green-text'
            }
            break
          case this.monitorType.ANALYSING:
            info = {
              divClass: '',
              imgClass: 'w-44',
              imgSrc: 'analysing-pad.png',
              text: this.$t('text.analysing'),
              bottomDesc: '',
              privacyEventClass: this.privacyTypes.level6,
              simpleCircleClass: this.simpleTypes.level6,
              simpleImgSrc: 'simple-pad-gray.png',
              simpleImgClass: 'w-32',
              simpleOrPrivacyBottomTextClass: 'gray-text'
            }
            break
          case this.monitorType.PADNOTSELECTED:
            info = {
              divClass: '',
              imgClass: 'w-42 ml-5 mt-5',
              imgSrc: 'pad-not-selected.png',
              text: this.$t('text.not_selected'),
              bottomDesc: '',
              privacyEventClass: this.privacyTypes.level6,
              simpleCircleClass: this.simpleTypes.level6,
              simpleImgSrc: 'simple-pad-gray.png',
              simpleImgClass: 'w-32',
              simpleOrPrivacyBottomTextClass: 'gray-text'
            }
            break
          case this.monitorType.PADUNKNOWN:
            info = {
              divClass: '',
              imgClass: 'w-42 ml-5 mt-5',
              imgSrc: 'diaper-not-use.png',
              text: this.$t('text.non_smartz_product_in_use').toUpperCase(),
              bottomDesc: '',
              privacyEventClass: this.privacyTypes.level6,
              simpleCircleClass: this.simpleTypes.level6,
              simpleImgSrc: 'simple-pad-gray.png',
              simpleImgClass: 'w-32',
              simpleOrPrivacyBottomTextClass: 'gray-text'
            }
            break
          default:
            info = {
              divClass: 'monitor-green v-h-center',
              imgClass: 'w-32',
              imgSrc: 'pad.svg',
              text: '',
              bottomDesc: '',
              privacyEventClass: this.privacyTypes.level6,
              simpleCircleClass: this.simpleTypes.level6,
              simpleImgSrc: 'simple-pad.png',
              simpleImgClass: 'w-32',
              simpleOrPrivacyBottomTextClass: 'green-text'
            }
        }
        return info
      }
    },
    // calculate action required event time
    calculateTime() {
      return function(item) {
        let type = this.getActiveType(item).type
        let time
        if (
          [
            this.actionType.pod_unclipped,
            this.actionType.no_data_received,
            this.actionType.lowbattery,
            this.actionType.flatbattery
          ].includes(type)
        ) {
          time = item.data.startTimeForPodStatus
        } else if (type === this.actionType.check_pad) {
          time = item.data.startTimeForRed
        } else if (type === this.actionType.check_time_in_pad) {
          time = item.data.startTimeForRedPad
        } else if (type === this.actionType.check_fall) {
          time = item.data.startTimeForFall
        } else if (type === this.actionType.check_position) {
          time = item.data.startTimeForRedPos
        } else if (type === this.actionType.check_temperature) {
          time = item.data.startTimeForRedTemp
        }
        if (!time) return [0, 'm']
        return this.getTimeFormat(time)
      }
    },
    dashboardClass() {
      if (this.$store.getters[`user/isPrivacyMode`])
        return 'privacy-mode-dashboard'
      if (this.$store.getters[`user/isSimpleMode`])
        return 'simple-mode-dashboard'
      return ''
    }
  },
  watch: {
    screenWidth: {
      handler: _.debounce(function() {
        if (this.loading) return
        this.initData()
        this.getData('all')
      }, 500),
      deep: true
    },
    screenHeight: {
      handler: _.debounce(function() {
        if (this.loading) return
        this.initData()
        this.getData('all')
      }, 500),
      deep: true
    },
    '$route.query'() {
      this.getHightLightPatient()
    },
    '$store.state.filter.dashboardFilter': {
      handler: _.debounce(function() {
        this.initData()
        this.getData('all')
      }, 100),
      deep: true
    }
  },
  methods: {
    getTimeFormat(time) {
      let minutes = moment().diff(moment.utc(time), 'minutes')
      if (minutes < this.showTimeGreaterThanMinutes) return [0, 'm']
      if (minutes >= 1440) {
        let day = Math.round(minutes / 1440)
        return [day, 'd']
      } else if (minutes >= 60 && minutes < 1440) {
        let hour = Math.round(minutes / 60)
        return [hour, 'h']
      } else {
        return [minutes, 'm']
      }
    },
    checkNodeNetwork() {
      if (this.isDemoOrg) return false
      ApiService.CheckNodeNetwork(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          if (response.data.success) {
            if (!response.data.data.networkHealthy) {
              this.showNodeNetworkError()
            }
          } else {
            this.showNodeNetworkError()
          }
        })
        .catch(() => {
          this.showNodeNetworkError()
        })
    },
    showNodeNetworkError() {
      if (this.displayNodeNetworkError) return false // if node network already display, then no need display again.
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.displayNodeNetworkError = true
      MessageBox.confirm(
        `<div class="warning-content">${this.$t(
          'text.node_network_error_msg'
        )}.</div> <img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.warning'),
        {
          confirmButtonText: this.$t('text.ok'),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      ).then(() => {
        this.displayNodeNetworkError = false
      })
    },
    getHightLightPatient() {
      if (this.$route.query && this.$route.query.hightLightPatientId) {
        this.hightLightPatientId = this.$route.query.hightLightPatientId
      }
    },
    onPatientUpdated(response) {
      let isAdded = true
      this.responseData.forEach((item, index) => {
        if (item.patientId === response.patientId) {
          isAdded = false
          this.responseData.splice(index, 1, {
            patientId: item.patientId,
            alias: response.alias,
            data: {
              ...item.data,
              podMac: response.podMac
            }
          })
        }
      })
      if (isAdded) {
        this.responseData.push(response)
      }
      if (!isAdded) {
        this.initData()
        this.handleData('all')
      }
    },
    onPatientStatusUpdated(response) {
      let isApplyUpdate = false
      this.responseData.forEach((item, index) => {
        // The messageOrderNumber attribute is the sequence attribute carried by the signalR service
        // In order to solve the problem that the signalR service does not send messages in the correct order
        if (
          item.patientId === response.patientId &&
          (!item.messageOrderNumber ||
            item.messageOrderNumber < response.messageOrderNumber)
        ) {
          isApplyUpdate = true
          this.responseData.splice(index, 1, {
            ...item,
            data: {
              ...response.data,
              isUpgraded: item.data.hasOwnProperty('isUpgraded')
                ? item.data.isUpgraded
                : true // signalr service don't return isUpgraded field, so preserved the value in API
            },
            messageOrderNumber: response.messageOrderNumber || 0
          })
        }
      })
      if (isApplyUpdate) {
        this.initData()
        this.handleData('all')
      }
    },
    onPatientMoved(data) {
      this.responseData.forEach((item, index) => {
        if (item.patientId === data.patientId) {
          this.responseData.splice(index, 1)
        }
      })
      this.initData()
      this.handleData('all')
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
      this.screenHeight = window.innerHeight
    },
    toogleActive() {
      for (let i in this.actions) {
        this.actions[i].forEach((action, index) => {
          this.handleToogleActive(action, index, i)
        })
      }
    },
    handleToogleActive(ele, index, type) {
      let actionActive = this.getActiveType(ele)
      let activeIndex = 0
      ele.warnings.forEach((item, index) => {
        if (item.type === actionActive.type) {
          activeIndex = index
        }
      })
      let newActions = []
      var currentActiveIndex =
        activeIndex === ele.warnings.length - 1 ? 0 : activeIndex + 1
      ele.warnings.forEach((item, index) => {
        item.active = index === currentActiveIndex
        item.cycled = true
        newActions.push(item)
      })
      ele.warnings = newActions
      if (ele.warnings.length > 1) {
        setTimeout(() => {
          $('.' + type + '-action-section .dashboard-item-card')
            .eq(index)
            .find('.circle')
            .find('img')
            .stop()
            .removeClass('rotate')
            .addClass('rotate')
        }, 1)
      }
    },
    initData() {
      this.actions = {
        top: [],
        bottom: []
      }
      this.notShownActions = {
        top: [],
        bottom: []
      }
      this.monitors = {
        top: [],
        bottom: []
      }
      this.notShownMonitors = {
        top: [],
        bottom: []
      }
      clearInterval(this.actionCycleTimer.top)
      clearInterval(this.actionCycleTimer.bottom)
      clearInterval(this.monitorCycleTimer.top)
      clearInterval(this.monitorCycleTimer.bottom)
      this.actionCycleTimer = {
        top: '',
        bottom: ''
      }
      this.monitorCycleTimer = {
        top: '',
        bottom: ''
      }
    },
    getData(type) {
      this.loading = true
      ApiService.GetAllPodsStatus(
        this.$store.getters[`filter/calculatedFilter`].organisationId,
        this.$store.getters[`filter/calculatedFilter`].flag,
        this.$store.getters[`filter/calculatedFilter`].filterIds
      )
        .then(response => {
          this.responseData = response.data
          this.loading = false
          this.calcEachRowItemCount()
          this.calculatePerPageItem()
          this.handleData(type)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getFallCardNumber() {
      let count = 0
      this.responseData.forEach(item => {
        if (item.data && item.data.fallStatus === 'RED') {
          count++
        }
      })
      return count
    },
    handleData(type) {
      if (type === 'all' || type.indexOf('action') > -1) {
        this.filterActions(this.responseData, type)
      }
      if (type === 'all' || type.indexOf('monitor') > -1) {
        this.filterMonitors(this.responseData, type)
      }
    },
    filterActions(response, type) {
      let calcResult = this.calcActions(response)
      // On a small screen, all the data is displayed
      if (
        this.screenWidth <= this.maxCycleScreenWidth ||
        this.screenHeight <= this.maxCycleScreenHeight
      ) {
        this.actions = {
          top: calcResult.actionsTop,
          bottom: calcResult.actionsBottom
        }
        this.notShownActions = {
          top: [],
          bottom: []
        }
        return false
      }
      this.calcActionsShownOrNot(
        calcResult.actionsTop,
        calcResult.actionsBottom,
        type
      )

      if (this.notShownActions.top.length && !this.actionCycleTimer.top) {
        this.actionCycleTimer.top = setInterval(() => {
          this.cycleActionsTop()
        }, this.cycleInterval)
      }
      if (this.notShownActions.bottom.length && !this.actionCycleTimer.bottom) {
        this.actionCycleTimer.bottom = setInterval(() => {
          this.cycleActionsBottom()
        }, this.cycleInterval)
      }
    },
    needTakeAction(item) {
      return (
        item.data &&
        (item.data.podStatus === 'RED' ||
          item.data.podStatus === 'MAXCAPACITY' ||
          item.data.positionStatus === 'RED' ||
          item.data.temperatureStatus === 'RED' ||
          item.data.podStatus === 'DISCONNECTED' ||
          item.data.podStatus === 'NODATARECEIVED' ||
          item.data.podStatus === 'LOWBATTERY' ||
          item.data.podStatus === 'FLATBATTERY' ||
          item.data.padStatus === 'RED' ||
          item.data.fallStatus === 'RED') &&
        !['ANALYSING', 'PADNOTSELECTED', 'PADUNKNOWN'].includes(
          item.data.podStatus
        )
      )
    },
    calcActions(response) {
      let actions = response.filter(item => {
        return this.needTakeAction(item)
      })
      actions = actions.map(item => {
        // default priority is 0
        item.statusChangeTime = moment().diff(
          moment.utc(item.data.padCycleStartTime),
          'seconds'
        )
        item.priority = 0
        if (item.data.fallStatus === 'RED') {
          item.priority = 1
          item.warnings = [
            {
              type: this.actionType.check_fall
            }
          ]
        } else if (item.data.podStatus === 'LOWBATTERY') {
          item.warnings = [
            {
              type: this.actionType.lowbattery
            }
          ]
        } else if (item.data.podStatus === 'FLATBATTERY') {
          item.warnings = [
            {
              type: this.actionType.flatbattery
            }
          ]
        } else if (item.data.podStatus === 'DISCONNECTED') {
          item.warnings = [
            {
              type: this.actionType.pod_unclipped
            }
          ]
        } else if (item.data.podStatus === 'NODATARECEIVED') {
          item.warnings = [
            {
              type: this.actionType.no_data_received
            }
          ]
        } else if (
          item.data.podStatus === 'RED' ||
          item.data.podStatus === 'MAXCAPACITY'
        ) {
          // MAXCAPACITY behave same as RED
          item.warnings = [
            {
              type: this.actionType.check_pad
            }
          ]
        } else if (item.data.padStatus === 'RED') {
          item.warnings = [
            {
              type: this.actionType.check_time_in_pad
            }
          ]
        } else {
          //other warnings
          item.warnings = []
          if (item.data.positionStatus === 'RED') {
            item.warnings.push({
              type: this.actionType.check_position
            })
          }
          if (item.data.temperatureStatus === 'RED') {
            item.warnings.push({
              type: this.actionType.check_temperature
            })
          }
        }

        item.warnings[0].active = true
        item.warnings[0].cycled = true
        return {
          ...item
        }
      })
      //order by redStartTime
      this.sortArray(actions, 'redStartTime', 'asc')
      //order by priority
      this.sortArray(actions, 'priority')
      const actionsTop = actions.filter(item => {
        const itemWarnings = item.warnings.map(warning => {
          return warning.type
        })
        return (
          itemWarnings.includes(this.actionType.check_pad) ||
          itemWarnings.includes(this.actionType.check_time_in_pad)
        )
      })
      const actionsBottom = actions.filter(item => {
        const itemWarnings = item.warnings.map(warning => {
          return warning.type
        })
        return !(
          itemWarnings.includes(this.actionType.check_pad) ||
          itemWarnings.includes(this.actionType.check_time_in_pad)
        )
      })
      return {
        actions,
        actionsTop,
        actionsBottom
      }
    },
    // Calculate which data to display directly and which to put in the queue
    calcActionsShownOrNot(actionsTop, actionsBottom, type) {
      let calcActions
      let calcNotShownActions
      const totalRow = Math.ceil(this.totalItemCount / this.eachRowItemCount)
      let topRow = Math.ceil(actionsTop.length / this.eachRowItemCount)
      let bottomRow = Math.ceil(actionsBottom.length / this.eachRowItemCount)
      // If the screen can show all the data
      if (totalRow >= topRow + bottomRow) {
        calcActions = {
          top: actionsTop,
          bottom: actionsBottom
        }
        calcNotShownActions = {
          top: [],
          bottom: []
        }
      } else {
        // If the screen can fully display the top data, the top data is displayed first, and the remaining space displays the bottom data
        if (topRow < totalRow) {
          bottomRow = totalRow - topRow
          let bottomItemCount = bottomRow * this.eachRowItemCount
          calcActions = {
            top: actionsTop,
            bottom: actionsBottom.slice(0, bottomItemCount)
          }
          calcNotShownActions = {
            top: [],
            bottom: actionsBottom.slice(
              bottomItemCount,
              actionsBottom.length + 1
            )
          }
        } else {
          // Leave one row for the lower part
          bottomRow = actionsBottom.length ? 1 : 0
          topRow = totalRow - bottomRow
          calcActions = {
            top: actionsTop.slice(
              0,
              this.totalItemCount - this.eachRowItemCount * bottomRow
            ),
            bottom: actionsBottom.slice(0, this.eachRowItemCount * bottomRow)
          }
          calcNotShownActions = {
            top: actionsTop.slice(
              this.totalItemCount - this.eachRowItemCount * bottomRow,
              actionsTop.length + 1
            ),
            bottom: actionsBottom.slice(
              this.eachRowItemCount * bottomRow,
              actionsBottom.length + 1
            )
          }
        }
      }
      if (type === 'all' || type === 'actionTop') {
        if (
          this.actions.top.length &&
          actionsTop.length > topRow * this.eachRowItemCount
        ) {
          this.notShownActions.top = this.sortNotShownData(
            actionsTop,
            this.notShownActions.top
          )
        } else {
          this.actions.top = calcActions.top
          this.notShownActions.top = calcNotShownActions.top
        }
      }

      if (type === 'all' || type === 'actionBottom') {
        // 	falls card have highest priority and should be display from top left of bottom section of action required.
        //  If there are many falls card that can't be shown on the screen, flip the falls card to make sure all patients with falls we be eventually seen.
        if (
          this.actions.bottom.length &&
          actionsBottom.length > bottomRow * this.eachRowItemCount
        ) {
          if (
            this.getFallCardNumber() >= this.actions.bottom.length ||
            this.getFallCardNumber() === 0
          ) {
            this.notShownActions.bottom = this.sortNotShownData(
              actionsBottom,
              this.notShownActions.bottom
            )
          } else {
            // If the number of fall cards does not change, the previous inversion logic continues
            let lastFallCardArr = this.actions.bottom.filter(
              item => item.data.fallStatus === 'RED'
            )
            if (lastFallCardArr.length === this.getFallCardNumber()) {
              this.actions.bottom = this.actions.bottom.map((item, index) => {
                if (item.data.fallStatus === 'RED') {
                  let obj = actionsBottom[index]
                  obj.replaced = item.replaced
                  obj.removed = true
                  return obj
                } else {
                  return item
                }
              })
              this.notShownActions.bottom = this.sortNotShownData(
                actionsBottom.filter(item => !item.removed),
                this.notShownActions.bottom
              )
            } else {
              // else init data
              this.actions.bottom = calcActions.bottom
              this.notShownActions.bottom = calcNotShownActions.bottom
              clearInterval(this.actionCycleTimer.bottom)
              this.actionCycleTimer.bottom = setInterval(() => {
                this.cycleActionsBottom()
              }, this.cycleInterval)
            }
          }
        } else {
          this.actions.bottom = calcActions.bottom
          this.notShownActions.bottom = calcNotShownActions.bottom
        }
      }
    },

    cycleActionsTop() {
      if (
        this.notShownActions.top.length <
        this.actions.top.length / this.eachRowItemCount
      ) {
        this.handleData('actionTop')
        return false
      }
      let needReplaceIndex = 0
      for (var i = this.actions.top.length - 1; i >= 0; i--) {
        if (!this.actions.top[i].replaced) needReplaceIndex = i
      }
      $('.top-action-section .dashboard-item-card')
        .stop()
        .removeClass('rotate')
      for (
        var j = 0;
        j < this.actions.top.length / this.eachRowItemCount;
        j++
      ) {
        let index = needReplaceIndex + j * this.eachRowItemCount
        let newItem = JSON.parse(JSON.stringify(this.notShownActions.top[0]))
        newItem.replaced = true
        this.actions.top.splice(index, 1, newItem)
        this.notShownActions.top.splice(0, 1)
        this.$nextTick(() => {
          $('.top-action-section .dashboard-item-card')
            .eq(index)
            .addClass('rotate')
        })
      }

      let replacedCount = 0
      this.actions.top.forEach(item => {
        if (item.replaced) replacedCount++
      })
      if (replacedCount === this.actions.top.length) {
        this.actions.top = this.actions.top.map(item => {
          return {
            ...item,
            replaced: false
          }
        })
      }
    },
    cycleActionsBottom() {
      //  falls card have highest priority and should be display from top left of bottom section of action required.
      // If there are many falls card that can't be shown on the screen, flip the falls card to make sure all patients with falls we be eventually seen.
      if (
        this.getFallCardNumber() >= this.actions.bottom.length ||
        this.getFallCardNumber() === 0
      ) {
        this.cycleActionsBottomType1()
      } else {
        this.cycleActionsBottomType2()
      }
    },
    cycleActionsBottomType1() {
      if (
        this.notShownActions.bottom.length <
        this.actions.bottom.length / this.eachRowItemCount
      ) {
        this.handleData('actionBottom')
        return false
      }
      let needReplaceIndex = 0
      for (var i = this.actions.bottom.length - 1; i >= 0; i--) {
        if (!this.actions.bottom[i].replaced) needReplaceIndex = i
      }
      $('.bottom-action-section .dashboard-item-card')
        .stop()
        .removeClass('rotate')
      for (
        var j = 0;
        j < this.actions.bottom.length / this.eachRowItemCount;
        j++
      ) {
        let index = needReplaceIndex + j * this.eachRowItemCount
        let newItem = JSON.parse(JSON.stringify(this.notShownActions.bottom[0]))
        newItem.replaced = true
        this.actions.bottom.splice(index, 1, newItem)
        this.notShownActions.bottom.splice(0, 1)
        this.$nextTick(() => {
          $('.bottom-action-section .dashboard-item-card')
            .eq(index)
            .addClass('rotate')
        })
      }

      let replacedCount = 0
      this.actions.bottom.forEach(item => {
        if (item.replaced) replacedCount++
      })
      if (replacedCount === this.actions.bottom.length) {
        this.actions.bottom = this.actions.bottom.map(item => {
          return {
            ...item,
            replaced: false
          }
        })
      }
    },
    cycleActionsBottomType2() {
      if (
        this.notShownActions.bottom.length <
        this.actions.bottom.length / this.eachRowItemCount
      ) {
        this.handleData('actionBottom')
        return false
      }
      let realRotate = false
      let needReplaceIndex = 0
      for (var i = this.actions.bottom.length - 1; i >= 0; i--) {
        if (!this.actions.bottom[i].replaced) needReplaceIndex = i
      }
      $('.bottom-action-section .dashboard-item-card')
        .stop()
        .removeClass('rotate')
      for (
        var j = 0;
        j < this.actions.bottom.length / this.eachRowItemCount;
        j++
      ) {
        let index = needReplaceIndex + j * this.eachRowItemCount
        if (this.actions.bottom[index].data.fallStatus !== 'RED') {
          let newItem = JSON.parse(
            JSON.stringify(this.notShownActions.bottom[0])
          )
          newItem.replaced = true
          this.actions.bottom.splice(index, 1, newItem)
          this.notShownActions.bottom.splice(0, 1)
          this.$nextTick(() => {
            $('.bottom-action-section .dashboard-item-card')
              .eq(index)
              .addClass('rotate')
          })
          realRotate = true
        } else {
          this.actions.bottom[index].replaced = true
        }
      }

      let replacedCount = 0
      this.actions.bottom.forEach(item => {
        if (item.replaced) replacedCount++
      })
      if (replacedCount === this.actions.bottom.length) {
        this.actions.bottom = this.actions.bottom.map(item => {
          return {
            ...item,
            replaced: false
          }
        })
      }
      if (!realRotate) this.cycleActionsBottomType2()
    },

    filterMonitors(response, type) {
      let calcResult = this.calcMonitors(response)
      // On a small screen, all the data is displayed
      if (
        this.screenWidth <= this.maxCycleScreenWidth ||
        this.screenHeight <= this.maxCycleScreenHeight
      ) {
        this.monitors = {
          top: calcResult.monitorsTop,
          bottom: calcResult.monitorsBottom
        }
        this.notShownMonitors = {
          top: [],
          bottom: []
        }
        return false
      }
      this.calcMonitorsShownOrNot(
        calcResult.monitorsTop,
        calcResult.monitorsBottom,
        type
      )

      if (this.notShownMonitors.top.length && !this.monitorCycleTimer.top) {
        this.monitorCycleTimer.top = setInterval(() => {
          this.cycleMonitorsTop()
        }, this.cycleInterval)
      }
      if (
        this.notShownMonitors.bottom.length &&
        !this.monitorCycleTimer.bottom
      ) {
        this.monitorCycleTimer.bottom = setInterval(() => {
          this.cycleMonitorsBottom()
        }, this.cycleInterval)
      }
    },
    calcMonitors(response) {
      let monitors = response.filter(item => {
        return !this.needTakeAction(item)
      })
      monitors = monitors.map(item => {
        item.warnStatus = item.data.podStatus
        if (item.data.positionStatus === 'YELLOW') {
          item.warnStatus === 'YELLOW'
        }
        return {
          ...item,
          common_value: monitorType[item.warnStatus]
        }
      })
      // sort by redStartTime
      this.sortArray(monitors, 'redStartTime', 'asc')
      //green status shown in front
      this.sortArray(monitors, 'common_value')

      const topSection = [
        this.monitorType['YELLOW'],
        this.monitorType['UNSTABLE'],
        this.monitorType['WETSURFACE'],
        this.monitorType['CLUMPED'],
        this.monitorType['CLUMPED-GREEN'],
        this.monitorType['CLUMPED-YELLOW'],
        this.monitorType['GREEN']
      ]
      const monitorsTop = monitors.filter(item => {
        return topSection.includes(item.common_value)
      })
      const monitorsBottom = monitors.filter(item => {
        return !topSection.includes(item.common_value)
      })
      return {
        monitors,
        monitorsTop,
        monitorsBottom
      }
    },
    // Calculate which data to display directly and which to put in the queue
    calcMonitorsShownOrNot(monitorsTop, monitorsBottom, type) {
      let calcMonitors
      let calcNotShownMonitors
      const totalRow = Math.ceil(this.totalItemCount / this.eachRowItemCount)
      let topRow = Math.ceil(monitorsTop.length / this.eachRowItemCount)
      let bottomRow = Math.ceil(monitorsBottom.length / this.eachRowItemCount)
      // If the screen can show all the data
      if (totalRow >= topRow + bottomRow) {
        calcMonitors = {
          top: monitorsTop,
          bottom: monitorsBottom
        }
        calcNotShownMonitors = {
          top: [],
          bottom: []
        }
      } else {
        // If the screen can fully display the top data, the top data is displayed first, and the remaining space displays the bottom data
        if (topRow < totalRow) {
          bottomRow = totalRow - topRow
          let bottomItemCount = bottomRow * this.eachRowItemCount
          calcMonitors = {
            top: monitorsTop,
            bottom: monitorsBottom.slice(0, bottomItemCount)
          }
          calcNotShownMonitors = {
            top: [],
            bottom: monitorsBottom.slice(
              bottomItemCount,
              monitorsBottom.length + 1
            )
          }
        } else {
          // Leave one row for the lower part
          bottomRow = monitorsBottom.length ? 1 : 0
          topRow = totalRow - bottomRow
          calcMonitors = {
            top: monitorsTop.slice(
              0,
              this.totalItemCount - this.eachRowItemCount * bottomRow
            ),
            bottom: monitorsBottom.slice(0, this.eachRowItemCount * bottomRow)
          }
          calcNotShownMonitors = {
            top: monitorsTop.slice(
              this.totalItemCount - this.eachRowItemCount * bottomRow,
              monitorsTop.length + 1
            ),
            bottom: monitorsBottom.slice(
              this.eachRowItemCount * bottomRow,
              monitorsBottom.length + 1
            )
          }
        }
      }
      if (type === 'all' || type === 'monitorTop') {
        if (
          this.monitors.top.length &&
          monitorsTop.length > topRow * this.eachRowItemCount
        ) {
          this.notShownMonitors.top = this.sortNotShownData(
            monitorsTop,
            this.notShownMonitors.top
          )
        } else {
          this.monitors.top = calcMonitors.top
          this.notShownMonitors.top = calcNotShownMonitors.top
        }
      }

      if (type === 'all' || type === 'monitorBottom') {
        if (
          this.monitors.bottom.length &&
          monitorsBottom.length > bottomRow * this.eachRowItemCount
        ) {
          this.notShownMonitors.bottom = this.sortNotShownData(
            monitorsBottom,
            this.notShownMonitors.bottom
          )
        } else {
          this.monitors.bottom = calcMonitors.bottom
          this.notShownMonitors.bottom = calcNotShownMonitors.bottom
        }
      }
    },
    cycleMonitorsTop() {
      if (
        this.notShownMonitors.top.length <
        this.monitors.top.length / this.eachRowItemCount
      ) {
        this.handleData('monitorTop')
        return false
      }
      let needReplaceIndex = 0
      for (var i = this.monitors.top.length - 1; i >= 0; i--) {
        if (!this.monitors.top[i].replaced) needReplaceIndex = i
      }
      $('.top-monitor-section .dashboard-item-card')
        .stop()
        .removeClass('rotate')
      for (
        var j = 0;
        j < this.monitors.top.length / this.eachRowItemCount;
        j++
      ) {
        let index = needReplaceIndex + j * this.eachRowItemCount
        let newItem = JSON.parse(JSON.stringify(this.notShownMonitors.top[0]))
        newItem.replaced = true
        this.monitors.top.splice(index, 1, newItem)
        this.notShownMonitors.top.splice(0, 1)
        this.$nextTick(() => {
          $('.top-monitor-section .dashboard-item-card')
            .eq(index)
            .addClass('rotate')
        })
      }

      let replacedCount = 0
      this.monitors.top.forEach(item => {
        if (item.replaced) replacedCount++
      })
      if (replacedCount === this.monitors.top.length) {
        this.monitors.top = this.monitors.top.map(item => {
          return {
            ...item,
            replaced: false
          }
        })
      }
    },
    cycleMonitorsBottom() {
      if (
        this.notShownMonitors.bottom.length <
        this.monitors.bottom.length / this.eachRowItemCount
      ) {
        this.handleData('monitorBottom')
        return false
      }
      let needReplaceIndex = 0
      for (var i = this.monitors.bottom.length - 1; i >= 0; i--) {
        if (!this.monitors.bottom[i].replaced) needReplaceIndex = i
      }
      $('.bottom-monitor-section .dashboard-item-card')
        .stop()
        .removeClass('rotate')
      for (
        var j = 0;
        j < this.monitors.bottom.length / this.eachRowItemCount;
        j++
      ) {
        let index = needReplaceIndex + j * this.eachRowItemCount
        let newItem = JSON.parse(
          JSON.stringify(this.notShownMonitors.bottom[0])
        )
        newItem.replaced = true
        this.monitors.bottom.splice(index, 1, newItem)
        this.notShownMonitors.bottom.splice(0, 1)
        this.$nextTick(() => {
          $('.bottom-monitor-section .dashboard-item-card')
            .eq(index)
            .addClass('rotate')
        })
      }

      let replacedCount = 0
      this.monitors.bottom.forEach(item => {
        if (item.replaced) replacedCount++
      })
      if (replacedCount === this.monitors.bottom.length) {
        this.monitors.bottom = this.monitors.bottom.map(item => {
          return {
            ...item,
            replaced: false
          }
        })
      }
    },
    sortArray(array, orderBy, direction = 'desc') {
      array.sort((a, b) => {
        let valA = a[orderBy]
        let valB = b[orderBy]

        if (orderBy === 'redStartTime') {
          let dateA = Date.parse(valA)
          let dateB = Date.parse(valB)
          valA = isNaN(dateA) ? 0 : dateA
          valB = isNaN(dateB) ? 0 : dateB

          if (valA === 0 && valB !== 0) return 1
          if (valB === 0 && valA !== 0) return -1
        }

        if (valA < valB) {
          return direction === 'asc' ? -1 : 1
        } else if (valA > valB) {
          return direction === 'asc' ? 1 : -1
        } else {
          return 0
        }
      })
    },
    // Sort the latest arrived queue data based on the data to be presented
    sortNotShownData(latestData, queueData) {
      let firstIndex = 0
      if (queueData.length) {
        latestData.forEach((item, index) => {
          if (
            item.patientId === queueData[0].patientId &&
            item.alias === queueData[0].alias
          ) {
            firstIndex = index
          }
        })
      }
      if (firstIndex === 0) {
        queueData = latestData
      } else {
        queueData = latestData
          .slice(firstIndex, latestData.length + 1)
          .concat(latestData.slice(0, firstIndex))
      }
      return queueData
    },
    async toIndividual(item) {
      if (this.$store.getters[`user/isPrivacyMode`]) {
        return false
      }
      if (!this.$permission('Patients.View')) {
        return false
      }

      const allPatientIds = this.$store.state.patient.patients.map(
        item => item.patientId
      )
      // Sometimes, it is impossible to find the selected patient, which will cause the system to always display the first patient in the individual dashboard.
      // Use this logic to improve this situation
      if (!allPatientIds.includes(item.patientId)) {
        try {
          await this.$store.dispatch('patient/fetchPatients')
        } catch (error) {
          console.error('Failed to fetch patients:', error)
        }
      }

      const patient = this.$store.state.patient.patients.find(
        p => p.patientId === item.patientId
      )

      if (patient) {
        this.$store.commit('patient/SET_SELECTED_PATIENT', patient)
      } else {
        console.warn(
          'The selected patient is not in the list returned by /Board/GetPatient.'
        )
      }
      this.$router.push('/patients/monitor')
    },
    // Calculate the maximum number of displays
    calculatePerPageItem() {
      let totalHeight = $(window).height() - 210
      this.totalItemCount =
        Math.floor(totalHeight / 180) * this.eachRowItemCount
    },
    calcEachRowItemCount() {
      if (this.screenWidth > 1500) {
        this.eachRowItemCount = 4
      } else if (
        (this.screenWidth > 700 && this.screenWidth < 991) ||
        (this.screenWidth > 1100 && this.screenWidth < 1500)
      ) {
        this.eachRowItemCount = 3
      } else {
        this.eachRowItemCount = 2
      }
    },
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    clearFlipInterval() {
      clearInterval(this.refreshDataTimer)
      clearInterval(this.actionCycleTimer.top)
      clearInterval(this.actionCycleTimer.bottom)
      clearInterval(this.monitorCycleTimer.top)
      clearInterval(this.monitorCycleTimer.bottom)
    }
  },
  beforeDestroy() {
    clearInterval(this.activeTimer)
    this.clearFlipInterval()
    clearInterval(this.checkNodeNetworkTimer)
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  height: calc(100% - 60px);
  min-height: 300px;
  width: calc(100% - 20px);
  margin: 0 auto;
}
@media (max-width: 1319px) and (min-width: 1266px) {
  .no-data {
    max-width: calc(100% - 5px);
  }
}
</style>
